import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function CreateMetal({ username, onClose }) {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        comment: "",
        user_transaction: username,
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCreate = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/materials/types/insert`, formData, headers);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                navigate('/metal-types');
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Metal already exists, please try another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    const validateForm = () => {
        const { name } = formData;
        const newErrors = {};

        if (name.length < 3) {
            newErrors.name = 'Name must be at least 3 characters';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className="page-content" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <center>
                                <h4>Create Material type</h4>
                            </center>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <Link className='btn btn-warning' to="/metal-types" onClick={onClose}>Go Back</Link>
                        </div>

                        <div className="modal-body">
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="name" className="form-label">Name<span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                            placeholder="Enter metal name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="comment" className="form-label">Code</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter code"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? "Creating..." : "Create"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateMetal;
